module.exports = __webpack_public_path__ + "img/psd.ba2432b4.png";